import React, { FunctionComponent } from 'react'
import classnames from 'classnames'
import capitalize from 'lodash/capitalize'
import startCase from 'lodash/startCase'

import greenCheck from '../../assets/images/green-check.svg'
import pendingIcon from '../../assets/images/icon-pending.svg'

const renderIcon = (status) => {
  switch (status) {
    case 'APPROVED':
      return <img alt="" src={greenCheck} />
    case 'COMPLETED':
      return <img alt="" src={greenCheck} />
    case 'PENDING':
      return <img alt="" src={pendingIcon} />
    default:
      return <div className="refi-transactions-todoCard__oval" />
  }
}

export interface Props {
  mode: string
  status: string
  title?: string
  type: string
}

export const RefiTransactionsTodoRow: FunctionComponent<Props> = ({
  mode,
  status,
  title,
  type,
}) => {
  const displayType = type === 'IMAGE' || type === 'TEXT' ? title : type
  return status && displayType && mode ? (
    <div
      className={classnames('refi-transactions-todoCard__status', {
        'refi-transactions-todoCard__status--pending': status === 'PENDING',
        'refi-transactions-todoCard__status--accepted':
          status === 'APPROVED' || status === 'COMPLETED',
        'refi-transactions-todoCard__status--rejected': status === 'REJECTED',
        'refi-transactions-todoCard__status--priority': status === 'PRIORITY',
        'refi-transactions-todoCard__status--missing-data':
          status === 'MISSING_DATA',
        'refi-transactions-todoCard__status--no-hover': mode === 'USER_TASK',
      })}
    >
      <div className="refi-transactions-todoCard__image">
        {renderIcon(status)}
      </div>
      <div className="refi-transactions-todoCard__type">
        {startCase(capitalize(displayType))}
      </div>
    </div>
  ) : null
}

RefiTransactionsTodoRow.displayName = 'RefiTransactionsTodoRow'
